import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  DashboardProspectionsFormSchema,
  RegisterUserStepMutation,
} from './DashboardProspectionsForm.types';
import { useMutation, useQueryClient } from 'react-query';
import Form from '../../../../../commons/Form/Form';
import { createProspectStepData } from './DashboardProspectionsForm.data';
import { getCreateProspectSchema } from './DashboardProspectionsForm.schema';
import { CREATE_PROSPECT_QUERY_KEY, createProspectQuery } from './DashboardProspectionsForm.query';
import { useNavigate } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const formProps = useForm<DashboardProspectionsFormSchema>({
    resolver: yupResolver(getCreateProspectSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { handleSubmit } = formProps;

  const { mutate } = useMutation<
    Awaited<ReturnType<RegisterUserStepMutation>>,
    Error,
    DashboardProspectionsFormSchema
  >((data) => createProspectQuery(data), {
    mutationKey: CREATE_PROSPECT_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: () => {
      navigate(0);
    },
    onError: (error) => {
      alert(error.message);
    },
  });

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <>
      <Form<DashboardProspectionsFormSchema>
        data={createProspectStepData}
        {...{ formProps, onSubmit }}
      />
    </>
  );
};
